<template>
	<div class="FilterList">
		<CheckBoxSelectItem
			v-for="item in items"
			:key="item.value"
			:item="item"
			@selectionChange="(state) => handleSelectionChange(item, state)"
		/>
	</div>
</template>

<script setup lang="ts">
import CheckBoxSelectItem from '@components/CheckBoxSelectItem/CheckBoxSelectItem.vue';
import { useCheckboxFilter } from '@composables/useCheckboxFilter';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { EducationalLevelFilterMapper } from '@app/routing/mappers/EducationalLevelFilterMapper';

const { items, handleSelectionChange } = useCheckboxFilter(
	EducationalLevelFilterMapper.getInstance(),
	FilterType.EDUCATION_LEVEL
);
</script>

<style scoped lang="scss">
.FilterList {
	width: 100%;
	padding-right: 2px;	// required for outline not to be cut off
}
</style>
